import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import LabeledProfilePhoto from './labeled_profile_photo';
import TaskAssociations from './task_associations';
import TaskCheckbox from './task_checkbox';
import TaskIcon from './task_icon';

export default class VoucherApprovalTaskRow extends React.Component {
  static propTypes = {
    hideActions: PropTypes.bool,
    task: PropTypes.shape({
      assignees: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        initials: PropTypes.string,
        name: PropTypes.string.isRequired,
        profilePhotoUrl: PropTypes.string
      })).isRequired,
      associatedModels: PropTypes.arrayOf(PropTypes.shape({
        url: PropTypes.string.isRequired
      })).isRequired,
      completed: PropTypes.bool,
      id: PropTypes.number.isRequired,
      taskType: PropTypes.string
    }).isRequired
  }

  get voucher() {
    return this.props.task.associatedModels[0];
  }

  goToVoucher = () => {
    window.location.assign(`${this.voucher.url}?back_to=/contacts/tasks`);
  }

  render() {
    const { task } = this.props;

    return (
      <tr
        className={classNames('task', { 'task-completed': task.completed })}
        onClick={this.goToVoucher}
      >
        <td className="task-checkbox">
          <TaskCheckbox size="20px" task={task} onClick={this.goToVoucher} />
        </td>
        <td className="clickable fs-14">
          <div className="task-text">
            {task.title}
          </div>
        </td>
        <td className="hidden-xs hidden-sm">
          <TaskAssociations associations={task.associatedModels} id={task.id} />
        </td>
        <td className="task-icon hidden-xs hidden-sm">
          <TaskIcon size="sm" taskIsComplete={task.completed} type={task.taskType}/>
        </td>
        <td className="hidden-xs hidden-sm" />
        <td className="hidden-xs hidden-sm">
          {task.assignees.map(this.renderAssignee)}
        </td>
        <td className="hidden-xs hidden-sm" />
        {!this.props.hideActions && <td className="hidden-sm hidden-xs" />}
        <td className="visible-xs visible-sm" />
      </tr>
    );
  }

  renderAssignee = (assignee, index) => {
    return (
      <LabeledProfilePhoto
        initials={assignee.initials}
        key={index}
        label={index === 0 ? 'Assignee' : ''}
        photoUrl={assignee.profilePhotoUrl}
        value={assignee.name}
      />
    );
  }
}
